export const DASHBOARD_MONTH_LABELS = [
  "Jan",
  "Fev",
  "Mar",
  "Abr",
  "Mai",
  "Jun",
  "Jul",
  "Ago",
  "Set",
  "Out",
  "Nov",
  "Dez",
];

function toNumber(value) {
  const numericValue = Number(value);

  return Number.isFinite(numericValue) ? numericValue : 0;
}

function pickNumber(source, keys) {
  for (const key of keys) {
    const value = source?.[key];

    if (value !== undefined && value !== null && value !== "") {
      return toNumber(value);
    }
  }

  return 0;
}

function pickDate(source, keys) {
  for (const key of keys) {
    const value = source?.[key];

    if (!value) continue;

    const parsedDate = new Date(value);

    if (!Number.isNaN(parsedDate.getTime())) {
      return parsedDate;
    }
  }

  return null;
}

export function buildDashboardMonthlySeries(records, amountKeys = []) {
  const values = Array(12).fill(0);
  const currentYear = new Date().getFullYear();

  for (const record of records || []) {
    const recordDate = pickDate(record, [
      "createdAt",
      "updatedAt",
      "paidAt",
      "paymentDate",
      "date",
      "referenceDate",
      "valuationDate",
    ]);

    if (!recordDate || recordDate.getFullYear() !== currentYear) continue;

    const monthIndex = recordDate.getMonth();
    const amount = pickNumber(record, amountKeys);

    values[monthIndex] += amount;
  }

  return values.map((value) => Number(value.toFixed(2)));
}
